import { getParamFromUrl } from './url-search-params.functions'

function getTrackerId(url: string): string | null {
  return getParamFromUrl(url, 'trackerId')
}

export const TrackerIdFunctions = {
  getTrackerId,
}
